import { Button } from 'components/Button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from 'components/Dialog';
import { Flex } from 'components/layout';
import ButtonLoader from 'components/loading/ButtonLoader';
import { ButtonNamePosthog } from 'types/enums/CustomPosthogEvents';

type DeleteNoteDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isDeleting: boolean;
  onDelete: () => Promise<void>;
  loadID?: number;
};

export function DeleteNoteDialog({
  open,
  onOpenChange,
  isDeleting,
  onDelete,
  loadID,
}: DeleteNoteDialogProps) {
  const handleOpenChange = (nextOpen: boolean) => {
    if (!isDeleting) {
      onOpenChange(nextOpen);
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className='max-w-sm p-0 gap-0 overflow-hidden'>
        <Flex direction='col' gap='sm' className='px-4 py-4'>
          <DialogTitle>Delete Note?</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete this note?
          </DialogDescription>
        </Flex>

        <Flex
          justify='end'
          gap='sm'
          className='border-t border-neutral-300 bg-neutral-100 px-4 py-3 rounded-b-lg'
        >
          <Button
            buttonNamePosthog={null}
            type='button'
            variant='outline'
            size='sm'
            disabled={isDeleting}
            onClick={() => onOpenChange(false)}
            className='flex-1 text-sm'
          >
            Cancel
          </Button>
          <Button
            buttonNamePosthog={ButtonNamePosthog.DeleteNote}
            type='button'
            variant='destructive'
            size='sm'
            disabled={isDeleting}
            onClick={onDelete}
            logProperties={{ loadID }}
            className='flex-1 text-sm'
          >
            {isDeleting ? <ButtonLoader /> : 'Delete'}
          </Button>
        </Flex>
      </DialogContent>
    </Dialog>
  );
}
